import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VhQueryAutoWeb, VhEventMediator, VhAlgorithm } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { FunctionService} from 'vhobjects-service/src/services';
// import { FunctionService } from 'vhobjects-service';
import { MatDialog } from '@angular/material/dialog';
import { ColorContrastComponent } from '../../../../../color-contrast/color-contrast.component';
import { moveItemInArray } from '@angular/cdk/drag-drop';


@Component({
  selector: 'atw-search-config',
  templateUrl: './search-config.component.html',
  styleUrls: ['./search-config.component.scss'],
})
export class AtwSearchConfig implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;
  @Input() type: any; // xem đang ở page hay admin
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  // @Input() data_tool: any;
  // @Input() type_config: string;
  @Input() visible_config_tool = false;
  @Input() device: any;
  @Output() save = new EventEmitter();
  @Output() closeConfigEvent = new EventEmitter();
  @Output() closeConfigTool = new EventEmitter();

  main_sectors:any = [];
  isCollapsed: boolean = false;
  isViewAll: boolean = false;
  currentViewAll: any = {};
  stylefields = [
    {
      title: 'dieu_chinh_vien_o_tim_kiem',
      index: 1,
      isDrop: false
    },
    {
      title: 'dieu_chinh_vien_nut',
      index: 2,
      isDrop: false
    },
    {
      title: 'dieu_chinh_vien_item_ket_qua',
      index: 3,
      isDrop: false
    },
    {
      title: 'nen_o_tim_kiem',
      index: 4,
    },
    {
      title: "do_bao_phu",
      index: 5,
      isDrop: false
    },
    {
      title: 'dieu_chinh_vien_ket_qua',
      index: 6,
      isDrop: false
    },
    {
      title: 'nen_nut_tim_kiem',
      index: 7,
    },
    {
      title: 'dieu_chinh_vien_thanh_tim_kiem',
      index: 8,
      isDrop: false
    },
  ];
  arr_link_page: any = [];
  id_subproject: any = '';
  backgroundColor: any = [];

  fontsListItem = [
    { name: 'Times New Roman', value: 'Times New Roman' },
    { name: 'Georgia', value: 'Georgia' },
    { name: 'Palatino', value: 'Palatino' },
    { name: 'Baskerville', value: 'Baskerville' },
    { name: 'Arial', value: 'Arial' },
    { name: 'Arial black', value: 'Arial Black' },
    { name: 'Verdana', value: 'Verdana' },
    { name: 'Tahoma', value: 'Tahoma' },
    { name: 'Impact', value: 'Impact' },
    { name: 'Gill Sans', value: 'Gill Sans' },
    { name: 'Courier New', value: 'Courier New' },
    { name: 'Lucida', value: 'Lucida' },
    { name: 'Console', value: 'Console' },
    { name: 'Andalé Mono', value: 'Andalé Mono' },
    { name: 'Courier', value: 'Courier' },
    { name: 'Monaco', value: 'Monaco' },
    { name: 'Bradley Hand', value: 'Bradley Hand' },
    { name: 'Brush Script MT', value: 'Brush Script MT' },
    { name: 'Comic Sans MS', value: 'Comic Sans MS' },
    { name: 'Luminari', value: 'Luminari' },

    { name: 'Lobster', value: "'Lobster', cursive" },
    { name: 'Caveat', value: "'Caveat', cursive" },
    { name: 'Roboto', value: "'Roboto', sans-serif" },
    { name: 'Poppins', value: "'Poppins', sans-serif" },
    { name: 'Pacifico', value: "'Pacifico', cursive" },
  ];

  public positionOptions = [
    {
      label: 'Phải',
      value: 'Right',
    },
    {
      label: 'Trái',
      value: 'Left',
    },
  ];
  hidePriceMainSector = ['news', 'snimei', 'recruitment', 'category'];
  mainSectorTranslate: any = {
    news: "tin_tuc",
    category: "danh_muc",
    recruitment: "tuyen_dung",
    snimei: "bao_hanh",
    travel: "du_lich",
    webapp: "webapp",
    food_drink: "mon_an",
    service: "dich_vu",
    service_time: "dich_vu",
  };
  colorSelectedIndex = 0;


  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public vhEventMediator: VhEventMediator,
    private vhAlgorithm: VhAlgorithm,
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
    public functionService: FunctionService,
    private matDialog: MatDialog,
  ) { }


  ngOnInit(): void {
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/group/main_sectors.json'),
      this.http.get('assets/background-colors/background-colors.json'),
    ]).subscribe(([main_sectors, background_colors,]: any) => {
      this.main_sectors = this.vhAlgorithm.sortVietnamesebyASC(main_sectors.filter((item) => !['basic', 'branchs', 'member'].includes(item.value)),'label')
      this.backgroundColor = background_colors;
    });

    this.getLinkAllPages()
  }

  ngOnChanges(): void {
    if (!this.staticdata.accessibility) this.staticdata.accessibility = {}; 
    this.config.placeholder_change_color_auto ??= {
      enable: false,
      duration: 1000,
      color_list: ['#666666', '#4b8531', '#ff5722', '#2196f3', '#9c27b0'],
    };
    
    ['background-color-button', 'background-color-input'].forEach(key => {
      if (!this.config.hasOwnProperty(key)) {
        this.config[key] = {
          "gradient_arr": [
            "rgb(0, 0, 255)",
            "rgb(255, 255, 0)"
          ],
          "background": "#8c52ff",
          "gradient_check": false,
          "value_range": 1,
          "gradient_type": "linear-gradient",
          "value_parameter": 100,
          "gradient_direction": ""
        };
      }
    });
  }
  
  /**
   * Xử lý lấy link các page về.
   */
  getLinkAllPages() {
    this.vhQueryAutoWeb.getPages_byFields({}).then((pages: any) => {
      // Dùng cho trường hợp trang không có name_vn (Hoặc functionService.defaultLanguage)
      const pagesNew = pages.map((page) => {
        // if (!page.name) console.warn('Không có name', page)
        if (!page['name_' + this.functionService.defaultLanguage] && page.name) {
          return {
            ...page,
            ['name_' + this.functionService.defaultLanguage]: page.name
          };
        } else return page;
      });
      this.arr_link_page = this.vhAlgorithm.sortVietnamesebyASC(pagesNew, 'name_' + this.functionService.defaultLanguage);
    });
  }


  //Mở xem thêm
  openViewAll(field) {
    this.currentViewAll = field;
    this.isViewAll = !this.isViewAll;
  }

  // xử lý chỉ mở được 1 menu 1 lần
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false
  };
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }


  /**
   * @param index : vị trí phần tử muốn xóa
   * @param object : Loại vật thể để gán màu gradient (button, input, ...)
   * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
   */
  deleteGradient(index, object) {
    const gradientArr = this.config[`background-color-${object}`]?.gradient_arr;
  
    if (gradientArr?.length > 1) {
      gradientArr.splice(index, 1);
      this.updateBackgroundRgb(object);
    }
  }
  
  /**
   * Hàm này thực hiện thêm màu gradient vào array.
   * @param value : Màu gradient mới
   * @param object : Loại vật thể để gán màu gradient (button, input, ...)
   */
  addGradient(value, object) {
    if (!/#/.test(value)) return;

    const gradient = this.config[`background-color-${object}`];
    gradient?.gradient_arr?.push(`rgba(${this.hexToRGB(value)}, ${gradient.value_range})`);

    this.updateBackgroundRgb(object);
  }

  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');
    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }

  /**
   * hàm cập nhật background linear-gradient
   * @param type : Loại vật thể để gán màu gradient (button, input, ...)
   */
  updateBackgroundRgb(object) {
    this.class['search-box__' + object].background = this.config['background-color-' + object].gradient_check 
      ? "linear-gradient(" + this.config['background-color-' + object]['gradient_arr'] + ")"
      : this.config['background-color-' + object].background;
    this.updateObject();
  }

  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   * @param object : Loại vật thể để gán màu gradient (button, input, ...)
   */
  chooseOption(direction, event, object) {
    if (isPlatformBrowser(this.platformId)) {
      // Get class active của element khi click chọn hướng phối màu.
      // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
      var activeGradient = document.querySelector('.active-' + object) as HTMLElement;
      if (activeGradient) activeGradient.classList.remove('active-' + object);
      event.currentTarget.classList.add('active-' + object);
      // Gán các properties của phần tử direction vào biến trong json và cập nhật lưu vào database.
      this.config['background-color-' + object].gradient_type = direction.type;
      this.config['background-color-' + object].gradient_direction = direction.direction;
      this.class['search-box__' + object]['background'] = this.config['background-color-' + object].gradient_type + '(' + this.config['background-color-' + object].gradient_direction + this.config['background-color-' + object].gradient_arr.join(',') + ')'
      this.updateConfig();
      this.updateClass();
    }
  }

  /**
   * Hàm này dùng để click chọn màu nền của danh sách màu.
   * @param bgColor : trả về màu được chọn
   * @param event : trả về element được active
   * @param object : Loại vật thể để gán màu gradient (button, input, ...)
   */
  chooseBg(bgColor, event, object) {
    if (isPlatformBrowser(this.platformId)) {
      // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
      // Lấy ra element màu được click từ tham số event trả về.
      var activeGradient = document.querySelector(
        '.container-color .active-' + object
      ) as HTMLElement;
      if (activeGradient) activeGradient.classList.remove('active-' + object);
      event.currentTarget.classList.add('active-' + object);
      // Lấy giá trị màu được click từ tham số bgColor.
      //  Chuyển đổi màu được click thành mã rgb , thêm alpha vào mã rgb và lưu vào database.
      const data_background = this.class[`search-box__${object}`]
      data_background['background'] = bgColor.bgColor;
      data_background['background'] = `rgba(${this.hexToRGB(data_background['background'])}, ${this.config['background'].value_range})`;
      this.updateObject();
    }
  }


  // */ Hàm update object vào database.
  // */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {
        
      })
  }


  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => {
        
      });
  }


  updateConfig() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_config']: this.config,
        // data: this.data
      })
      .then((bool: any) => {
        
      });
  }


/** Xử lí lưu vị trí ảnh
  * -> xử lí dữ liệu bóng -> css:  object-position: `x y`
  */
  handleSetPositionImage() {
    if (this.config.object_fit_image.object_x == 0 && this.config.object_fit_image.object_y == 0)
      this.class['search-result__image']['object-position'] = 'initial';
    else {
      this.class['search-result__image']['object-position'] = `${this.config.object_fit_image.object_x}px ${this.config.object_fit_image.object_y}px`;
    }
    this.updateObject();
  }


  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['search-box']['width'] = event.width + 'px';
    if (event.height) this.class['search-box']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
    this.updateClass();
  }


  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    // Gọi hàm truy vấn cơ sở dữ liệu ở đây
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
    .then((bool) => {
    });
  }

  showResult() {
    this.vhEventMediator.notifyOnConfigChanged({
      id: this.objectChoosing._id,
      showResult: true,
    });
  }

  hideResult() {
    this.vhEventMediator.notifyOnConfigChanged({
      id: this.objectChoosing._id,
      showResult: false,
    });
  }

  /**
   * Mở popup so sánh màu nền và màu chữ có tương phản hay không
   * (Để tối ưu Accessibility trong SEO)
   */
  openColorContrast() {
    const colorClass = this.class['search-box__button-text'].color ? 'search-box__button-text' : 'search-box__button';
    const dialogRef = this.matDialog.open(ColorContrastComponent, {
      width: '30vw',
      height: 'fit-content',
      data: {
        /** Chứa map màu nền và màu chữ/icon */
        colorContrast: {
          typeFgColor: 'text',
          textOrIconColor: this.class[colorClass].color,
          bgColor: this.class['search-box__button']['background'],
        }
      },
    });

    dialogRef.afterClosed().subscribe((colorContrast) => {
      if (colorContrast) {
        this.class[colorClass].color = colorContrast.textOrIconColor;
        this.class['search-box__button']['background'] = colorContrast.bgColor;
        this.updateClass();
      }
    });
  }

  /**
   * Xử lý sự kiện kéo thả để thay đổi thứ tự các phần tử trong mảng.
   * @param {Object} item - Đối tượng chứa mảng dữ liệu.
   * @param {CdkDragDrop<string[]>} event - Sự kiện kéo thả từ Angular CDK.
   */
  handleListColorPositionDrop(event) {
    const colors = this.config.placeholder_change_color_auto?.color_list;
    if (colors?.length) {
      // 1. Thay đổi vị trí các phần tử trong mảng gốc
      moveItemInArray(
        colors, 
        event.previousIndex, 
        event.currentIndex
      );

      this.updateConfig();
    }
  }

  /**
   * Hàm theo dõi (trackBy) cho vòng lặp ngFor trong Angular.
   * Giúp Angular định danh các phần tử trong danh sách dựa trên chỉ số (index) 
   * thay vì giá trị của phần tử. Điều này ngăn chặn việc render lại toàn bộ DOM 
   * khi giá trị chuỗi thay đổi, từ đó khắc phục lỗi mất focus khi người dùng nhập liệu.
   * @param {number} index - Chỉ số của phần tử hiện tại trong mảng.
   * @param {any} item - Giá trị của phần tử tại vị trí index đó.
   * @returns {number} Trả về index để Angular dùng làm khóa định danh.
   */
  trackColorListByIndex(index: number, item: any): number {
    return index; // Theo dõi dựa trên vị trí, không quan tâm nội dung chuỗi thay đổi
  }

  /**
   * Hàm xử lý thêm một item color mới vào danh sách màu
   */
  handleAddColor() {    
    this.config.placeholder_change_color_auto?.color_list?.push('#ffff00');
    this.updateConfig();
  }

  /**
   * Hàm xử lý xoá một item màu trong danh sách color
   */
  handleRemoveColor(index: number) {    
    this.config.placeholder_change_color_auto?.color_list?.splice(index, 1);
    this.updateConfig();
  }
}
